import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to Fanestra",
    title: "Beautiful {Windows & Doors} for Every Home",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to Fanestra",
    title: "Premium Quality {Windows & Doors} for Your Space",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to Fanestra",
    title: "Elegant Solutions for Your {Windows & Doors Needs}",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
];

export default home;